import { type ReactElement } from 'react';

import Skeleton from '@/common/components//skeleton';

export function StoreInfoSkeleton(): ReactElement {
  return (
    <div className=" hidden  lg:mb-8 lg:mt-20 lg:flex lg:justify-between">
      <div className="flex gap-x-3">
        <Skeleton type="filter-tag" className="!h-16 !w-16 rounded-md" />
        <div className="mt-3 flex flex-col gap-y-3">
          <Skeleton type="filter-tag" className="!h-4 !w-32 rounded-md" />
          <Skeleton type="filter-tag" className="!h-4 !w-64 rounded-md" />
        </div>
      </div>
      <div className=" flex w-full items-end justify-end gap-x-4 ">
        <Skeleton
          type="filter-tag"
          className="!h-16 !w-16 rounded-md"
          repeat={4}
        />
      </div>
    </div>
  );
}
